import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import { App } from './App';
import { GlobalStyles } from './styles/global';
import { ErrorBoundary } from './components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { installGlobalErrorHandlers } from './utils/errorLog';

installGlobalErrorHandlers();

import './styles/theme.css';
import './styles/index.css';

declare global {
  interface Window {
    __APP_ENV__?: Record<string, unknown>;
  }
}

if (typeof window !== 'undefined') {
  window.__APP_ENV__ = {
    apiUrl: import.meta.env.VITE_API_URL ?? '/api',
    tokenKey: import.meta.env.VITE_TOKEN_KEY ?? 'authToken',
    swaggerUrl: import.meta.env.VITE_SWAGGER_JSON_URL,
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <GlobalStyles />
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <HashRouter>
          <ErrorBoundary level="app">
            <App />
          </ErrorBoundary>
        </HashRouter>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
